import React from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import useRequest from "utils/useRequest";
import { getCourseChannel } from "service/liveRecord";
import ListItem from "./components/ListItem";

interface PlayBackProps {
    courseNo: string;
    courseSeq: string;
}

export default function PlayBack({ courseNo, courseSeq }: PlayBackProps) {
    const [data, { loading }, refreshData] = useRequest(
        () => getCourseChannel(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.header}>
                    <div className={style.count}>
                        直播回放（{data?.length || 0}）
                        <span className={style.tip}>
                            说明：直播回放视频文件只保留180天。
                        </span>
                    </div>
                </div>

                {data?.length !== 0 &&
                    data?.map(item => (
                        <ListItem
                            key={item.vid}
                            data={item}
                            onChange={refreshData}
                        />
                    ))}
                {data?.length === 0 && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
